import { MouseEventHandler } from "react";
import "./AlertComponent.scss";
import { Alert, Typography, Stack } from "@mui/material";

interface AlertComponentProps {
  success?: boolean;
  children?: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
}
export const AlertComponent = ({
  success,
  children,
  onClick,
}: AlertComponentProps) => {
  return (
    <>
      <Stack width="100%" justifyContent="space-between">
        <Alert
          icon={false}
          severity={`${success ? "success" : "error"}`}
          className={`${success ? "success" : "error"} alertdiv`}
        >
          <Stack direction="row" gap="0.5rem" width="100%">
            <span
              className={`${
                success ? "t-icon-check" : "t-icon-CGU"
              } alert-icon`}
            />
            <Typography>{children}</Typography>
            <span
              onClick={onClick}
              className={`${!success && "d-none"} t-icon-close alert-icon`}
            />
          </Stack>
        </Alert>
      </Stack>
    </>
  );
};

export default AlertComponent;
